import React from 'react';
import type { LucideIcon } from 'lucide-react';

interface Props {
  icon: LucideIcon;
  title: string;
  description?: string;
  children: React.ReactNode;
}

export function SettingGroup({ icon: Icon, title, description, children }: Props) {
  return (
    <div className="bg-white border border-ink-300 rounded-xl overflow-hidden mb-3.5 shadow-xs">
      <div className="px-3.5 pt-3 pb-2 border-b border-ink-100">
        <div className={['flex items-center gap-2', description ? 'mb-1' : ''].join(' ')}>
          <Icon size={16} strokeWidth={2.25} className="text-green-700" />
          <span className="font-display font-bold text-[14px] text-ink-900">{title}</span>
        </div>
        {description && (
          <p className="m-0 text-[12px] text-ink-500 leading-snug">{description}</p>
        )}
      </div>
      <div>{children}</div>
    </div>
  );
}
